import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { AuthService } from '../services';

export const onboardingGuard: CanMatchFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.onboardingRequired()) return router.parseUrl('/onboarding');
  await auth.ensureProfileLoaded();
  return auth.onboardingRequired() ? router.parseUrl('/onboarding') : true;
};

export const onboardingPendingGuard: CanMatchFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.onboardingRequired()) return true;
  await auth.ensureProfileLoaded();
  return auth.onboardingRequired() ? true : router.parseUrl('/dashboard');
};
